const getDefaultState = () => {
  return {
    isAttack: false,
    type: "single",
    missEffect: "",
    maxTargets: "",
    primary: {
      stat: "Strength",
      bonusSource: "weapon",
      defense: "AC",
      staticBonus: "",
      weaponNumber: "",
      hitEffect: "",
      critRange: 20,
    },
    secondary: {
      target: "",
      stat: "Strength",
      bonusSource: "weapon",
      defense: "AC",
      staticBonus: "",
      weaponNumber: "",
      hitEffect: "",
      critRange: 20,
    },
    tertiary: {
      hasTertiary: false,
      target: "",
      stat: "Strength",
      bonusSource: "weapon",
      defense: "AC",
      staticBonus: "",
      weaponNumber: "",
      hitEffect: "",
      critRange: 20,
    },
    failedSaves: {
      first: "",
      second: "",
      third: "",
    },
  };
};

export default {
  namespaced: true,
  state: getDefaultState(),
  mutations: {
    resetState: (state) => Object.assign(state, getDefaultState()),
    // global
    setIsAttack: (state, value) => (state.isAttack = value),
    setType: (state, value) => (state.type = value),
    setMissEffect: (state, value) => (state.missEffect = value),
    setMaxTargets: (state, value) => (state.maxTargets = value),
    setFirstFailedSave: (state, value) => (state.failedSaves.first = value),
    setSecondFailedSave: (state, value) => (state.failedSaves.second = value),
    setThirdFailedSave: (state, value) => (state.failedSaves.third = value),
    // primary attack
    setStat: (state, value) => (state.primary.stat = value),
    setBonusSource: (state, value) => (state.primary.bonusSource = value),
    setDefense: (state, value) => (state.primary.defense = value),
    setStaticBonus: (state, value) => (state.primary.staticBonus = value),
    setWeaponNumber: (state, value) => (state.primary.weaponNumber = value),
    setHitEffect: (state, value) => (state.primary.hitEffect = value),
    setCritRange: (state, value) => (state.primary.critRange = value),
    // secondary attack
    setSecondaryTarget: (state, value) => (state.secondary.target = value),
    setSecondaryStat: (state, value) => (state.secondary.stat = value),
    setSecondaryBonusSource: (state, value) =>
      (state.secondary.bonusSource = value),
    setSecondaryDefense: (state, value) => (state.secondary.defense = value),
    setSecondaryStaticBonus: (state, value) =>
      (state.secondary.staticBonus = value),
    setSecondaryCritRange: (state, value) =>
      (state.secondary.critRange = value),
    setSecondaryWeaponNumber: (state, value) =>
      (state.secondary.weaponNumber = value),
    setSecondaryHitEffect: (state, value) =>
      (state.secondary.hitEffect = value),
    // tertiary attack
    setHasTertiary: (state, value) => (state.tertiary.hasTertiary = value),
    setTertiaryTarget: (state, value) => (state.tertiary.target = value),
    setTertiaryStat: (state, value) => (state.tertiary.stat = value),
    setTertiaryBonusSource: (state, value) =>
      (state.tertiary.bonusSource = value),
    setTertiaryDefense: (state, value) => (state.tertiary.defense = value),
    setTertiaryStaticBonus: (state, value) =>
      (state.tertiary.staticBonus = value),
    setTertiaryCritRange: (state, value) => (state.tertiary.critRange = value),
    setTertiaryWeaponNumber: (state, value) =>
      (state.tertiary.weaponNumber = value),
    setTertiaryHitEffect: (state, value) => (state.tertiary.hitEffect = value),
  },
};
